//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$NewsletterController_sync,
  Response$NewsletterController_sync$Status$201,
  ResponseContentType$NewsletterController_sync,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useNewsletterController_sync = () =>
  useApiClientMutation<
    Params$NewsletterController_sync,
    Response$NewsletterController_sync$Status$201[ResponseContentType$NewsletterController_sync]
  >({ method: 'NewsletterController_sync' });
